<script lang="ts">
	import { _ } from 'svelte-i18n';

	import IconC from '$lib/components/Icon/Icon.svelte';
	import type { Icon as IconType } from '$lib/components/Icon/Icon-types';
	import type { Editor } from 'svelte-tiptap';
	import Icon from '$lib/components/Icon/Icon.svelte';

	const FORMATTING: Array<IconType> = [
		'bold',
		'underline',
		'italic',
		'strikethrough',
		'code',
		'superscript',
		'subscript',
		'link',
	];
	type FormattingIcon = (typeof FORMATTING)[number];

	export let editor: Editor;

	const toggleFormatting = (icon: FormattingIcon) => {
		switch (icon) {
			case 'bold':
				editor?.chain().focus().toggleBold().run();
				break;
			case 'underline':
				editor?.chain().focus().toggleUnderline().run();
				break;
			case 'italic':
				editor?.chain().focus().toggleItalic().run();
				break;
			case 'strikethrough':
				editor?.chain().focus().toggleStrike().run();
				break;
			case 'code':
				editor?.chain().focus().toggleCode().run();
				break;
			case 'superscript':
				editor?.chain().focus().unsetSubscript().run();
				editor?.chain().focus().toggleSuperscript().run();
				break;
			case 'subscript':
				editor?.chain().focus().unsetSuperscript().run();
				editor?.chain().focus().toggleSubscript().run();
				break;
			case 'link':
				if (editor?.isActive('link')) {
					editor?.commands.unsetLink();
					return;
				}
				linkInputToggle = !linkInputToggle;
				setTimeout(() => {
					document.getElementById('urlInput')?.focus();
				}, 200);
		}
	};

	$: isSelected = (icon: FormattingIcon) => {
		if (icon === 'strikethrough') {
			return editor?.isActive('strike');
		} else {
			return editor?.isActive(icon);
		}
	};

	let linkInputToggle = false;

	const urlEvent = (event: KeyboardEvent) => {
		if (event.key === 'Enter') {
			editor?.commands.setLink({ href: (event.target as HTMLInputElement).value });
			linkInputToggle = false;
		}
	};
</script>

<ul>
	{#if !linkInputToggle}
		{#each FORMATTING as icon}
			<li>
				<div class="menuItem">
					<IconC
						onClick={() => {
							toggleFormatting(icon);
						}}
						{icon}
						size={'24'}
						color={isSelected(icon) ? '#3f8ce8' : 'white'} />
				</div>
			</li>
		{/each}
	{:else}
		<div class="urlInput">
			<input
				placeholder={$_('composer.placeholder.paste.or.type.link')}
				id="urlInput"
				type="url"
				on:keydown={urlEvent} />
			<Icon icon="close" size="24" color="black" onClick={() => (linkInputToggle = false)} />
		</div>
	{/if}
</ul>

<style>
	.urlInput {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	input {
		min-inline-size: 25rem;
		padding: var(--gutterSmall);
		border: none;
		border-radius: 5px;
		outline: none;
		background-color: #2a3039 !important;
		color: white;
	}

	ul {
		display: flex;
		flex-direction: row;
		border-radius: 5px;
		background-color: #2a3039 !important;
	}

	ul li {
		border-inline-end: 1px solid black;
		padding: var(--gutterSmallest);
	}

	li:last-of-type {
		border-inline-end: none;
	}
</style>
